/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedControlledHeadingWrapper_itemSearch = {
    readonly meta: {
        readonly subHeader: string | null;
    } | null;
    readonly " $refType": "SbSharedControlledHeadingWrapper_itemSearch";
};
export type SbSharedControlledHeadingWrapper_itemSearch$data = SbSharedControlledHeadingWrapper_itemSearch;
export type SbSharedControlledHeadingWrapper_itemSearch$key = {
    readonly " $data"?: SbSharedControlledHeadingWrapper_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedControlledHeadingWrapper_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedControlledHeadingWrapper_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subHeader",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'cb8487198d9bdb02a1467175dfae95fc';
export default node;
